import { UserRoleEnum } from '@/model/User';
import { SessionStorageEnum } from '@/utils/SessionStorageEnum';
import { RouteRecordRaw } from 'vue-router';
import { WalletRefundsRoutesEnum } from './WalletRefundsRoutesEnum';

const WalletRefundsPage = () => import(/* webpackChunkName: "WalletRefunds-module" */ '../pages/wallet-refunds/WalletRefundsPage.vue');
const WalletRefundDetail = () => import(/* webpackChunkName: "WalletRefunds-module" */ '../pages/wallet-refunds/WalletRefundDetail.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/app/wallet-refunds',
    name: WalletRefundsRoutesEnum.WALLET_REFUNDS_LIST,
    component: WalletRefundsPage,
    meta: {
      tabTitle: 'Rimborsi App',
      breadCrumbItems: [
        { label: 'Rimborsi App' },
      ],
      roles: [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.TMT_OPERATOR],
    },
    beforeEnter(_, __, next) {
      sessionStorage.removeItem(SessionStorageEnum.TABLE_STATE_WALLET_REFUNDS);
      next();
    },
  },
  {
    path: '/app/wallet-refunds/:id',
    name: WalletRefundsRoutesEnum.WALLET_REFUND_DETAIL,
    component: WalletRefundDetail,
    meta: {
      tabTitle: 'Dettaglio Rimborso',
      breadCrumbItems: [
        { label: 'Rimborsi App', to: { name: WalletRefundsRoutesEnum.WALLET_REFUNDS_LIST } },
        { label: 'Dettaglio' },
      ],
      roles: [UserRoleEnum.SUPER_ADMIN, UserRoleEnum.TMT_OPERATOR],
    },
  },
];

export { routes };
export { WalletRefundsRoutesEnum };
